module.exports = __webpack_public_path__ + "static/media/bam.eae5bc4f.jpg";